export const AGENT_NAMES = {
  0: "Shared Research",
  1: "Industry Intelligence",
  2: "Business Intelligence",
  3: "Stakeholder Intelligence",
  4: "Tech Intelligence",
  5: "Verification & Synthesis",
  6: "Account Plan",
  7: "Value Pyramid",
  8: "3Y Challenge",
  9: "Crazy4",
};
